import React from 'react';
import WorkOrderTable from '../WorkOrderTable';
import { BUYER_WO_FILTERS_ORDER } from '../../utils/WorkOrderUtils';
import posthog from 'posthog-js';
import WorkOrderFiltersWrapper from '../work_order_filters_wrapper/WorkOrderFiltersWrapper';

export default function WorkOrdersAllIndexPage() {
	return (
		<WorkOrderFiltersWrapper>
			{(defaultFilters) => (
				<WorkOrderTable
					handleQueryParams
					filterConfig={{
						filters: BUYER_WO_FILTERS_ORDER,
					}}
					preAppliedFilters={{}}
					targetCollectionName="allWorkOrdersIndex"
					initialFilters={defaultFilters}
				/>
			)}
		</WorkOrderFiltersWrapper>
	);
}
